import PropTypes from 'prop-types';
//import dynamic from 'next/dynamic';

// const Flag = dynamic(() => import('react-flagpack'), { ssr: false });

export default function CountryFlag({
  code,
}) {
  return (
    null
    // <Flag
    //   code={code}
    //   hasBorder={false}
    //   hasDropShadow
    //   hasBorderRadius
    // />
  );
}

CountryFlag.defaultProps = {};

CountryFlag.propTypes = {
  code: PropTypes.string.isRequired,
};
